<template>
  <div class="headMatter">
    <img src="../assets/logo.png" >
    <div class="title">蚁群科技</div>
  </div>
</template>

<script>
export default {
  name: 'headMatter',
  data () {
    return{}
  }
}
</script>

<style scoped lang="less">
  .headMatter{
    padding: 20px 0;
    background-color: #776FF7;
    display: flex;
    align-items: center;
    img{
      width: 70px;
      display: block;
      margin-left: 16px;
    }
    .title{
      color: #fff;
      font-size: 16px;
      line-height: 16px;
      margin-left: 15px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/headMatter.vue